import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';

import { sizeStyles } from './sizeStyles';
import { colorStyles } from './colorStyles';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.1s ease-out;

  ${sizeStyles}
  ${colorStyles}

  &:hover {
    transition: all 0.2s ease-out;
  }

  &.disabled {
    opacity: 0.3;
    cursor: not-allowed;
    transition: all 0.1s ease-out;
  }

  &.transparent {
    background-color: transparent;
  }

  &.circle {
    border-radius: 20px;
  }
`;

interface ButtonIconSecondaryProps {
  className?: string;
  size?: 'quadruple-xs' | 'triple-xs' | 'double-xs' | 'xs' | 'small' | 'medium' | 'large' | 'x-large';
  buttonStyle?:
    | 'gray1'
    | 'gray2'
    | 'gray3'
    | 'gray4'
    | 'white'
    | 'yellow'
    | 'blue'
    | 'red'
    | 'green'
    | 'black';
  shape?: 'square' | 'circle';
  icon?: React.ReactNode;

  onClick?: (e) => void;

  disabled?: boolean;
  transparent?: boolean;
}

export const ButtonIconSecondary = (props: ButtonIconSecondaryProps) => {
  const {
    className,
    icon,
    size = 'medium',
    buttonStyle = 'gray2',
    disabled = false,
    transparent = false,
    shape = 'square',
    onClick,
  } = props;

  return (
    <Container
      className={cl(
        'button-icon-secondary',
        buttonStyle,
        size,
        shape,
        { disabled, transparent },
        className
      )}
      onClick={(e) => !disabled && onClick?.(e)}
    >
      {icon}
    </Container>
  );
};
